import { render, staticRenderFns } from "./DepartmentsTree.vue?vue&type=template&id=11d73222&scoped=true"
import script from "./DepartmentsTree.vue?vue&type=script&lang=js"
export * from "./DepartmentsTree.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsTree.vue?vue&type=style&index=0&id=11d73222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d73222",
  null
  
)

export default component.exports